import Grid2 from '@mui/material/Unstable_Grid2';
import { useGetFactorialParamsQuery } from 'src/shared/api/integrations/factorial';
import { ShowLoading } from 'src/shared/components/ShowLoading';
import { Step2 } from './components/Step2';
import { Step3 } from './components/Step3';
import { Step4 } from './components/Step4';
import { Step5 } from './components/Step5';
import { Step6 } from './components/Step6';
import { ShowError } from 'src/shared/components/ShowError';
import { useFormState } from 'react-final-form';

type AfterConnectionProps = {
  isConnected?: boolean;
};

export const AfterConnection = ({ isConnected }: AfterConnectionProps) => {
  const { values } = useFormState();
  const { data, isLoading, isError, error } = useGetFactorialParamsQuery(
    { subsidiary: values.company },
    { skip: !isConnected }
  );

  if (isLoading && !data) {
    return <ShowLoading />;
  }

  if (isError) {
    return <ShowError error={error} />;
  }

  return (
    <>
      <Grid2>
        <Step2 data={data} />
      </Grid2>

      <Grid2>
        <Step3 data={data} />
      </Grid2>

      <Grid2>
        <Step4 data={data} />
      </Grid2>

      <Grid2>
        <Step5 />
      </Grid2>

      <Grid2>
        <Step6 />
      </Grid2>
    </>
  );
};
